import LookupTagRequestModelBase from '../_generated/modelBases/lookup-tag-request-model-base';

export default class LookupTagRequestModel extends LookupTagRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
